import React, { useEffect, useState } from 'react';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import { LecturerWithActivityId } from '../../../../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { Dropdown } from 'primereact/dropdown';
import { LecturerRatesVersions } from '../../../../../../../../api/types/lecturers/price-rate/lecturer-rate-res';
import { LecturerRatesById } from '../../../../../../../../api/types/lecturers/user-details-lecturer';
import { LecturerType } from '../../../../../../../../api/types/programs/course/lecturers/course-lecturer';
import globalConfigStore from '../../../../../../../../stores/global-config-store';
import appApi from '../../../../../../../../api/app-api';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { addNewProtectorsOperations } from './operation/add-new-protectors-operations';
import globalProgramStore from '../../../../../../../../stores/program-store';
import { ExamSessionDetails } from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { FindUser } from '../../../../../../../find-user-page/find-user';
import { UserSummaryType } from '../../../../../../../../api/types/user/user-summary.type';
import { UserType } from '../../../../../../../../api/types/user/user-type';

interface AddNewProtectorsDatamodel {
  examId: number;
  sessionId: number;
  classId: number;
  setExamDetails: (sessions: ExamSessionDetails[]) => any;
  onHide: () => any;
  forbiddenProtectorIds: number[];
}

export const AddNewProtectors: React.FC<AddNewProtectorsDatamodel> = ({
  examId,
  sessionId,
  classId,
  setExamDetails,
  onHide,
  forbiddenProtectorIds,
}) => {
  const [selectedLectures, setSelectedLectures] = useState<
    LecturerWithActivityId[] | null
  >(null);

  const [lecturerRateById, setLecturerRateById] =
    useState<LecturerRatesById | null>(null);

  // Convert UserSummaryType to LecturerWithActivityId and filter out forbidden protectors
  const handleUsersChange = (users: UserSummaryType[]) => {
    const filteredUsers = users.filter(
      (user) => !forbiddenProtectorIds.some((id) => id === user.id),
    );

    const lecturersWithActivityId: LecturerWithActivityId[] = filteredUsers.map(
      (user) => ({
        ...user,
        scheduledTeachingHours: 0,
        completedTeachingHours: 0,
        activityType: null,
      }),
    );

    setSelectedLectures(lecturersWithActivityId);
  };

  const handleSelectedActivityTypeForLecturer = (
    lecturer: LecturerType,
    selectedActivityType: LecturerRatesVersions,
  ) => {
    setSelectedLectures((prevSelectedLectures) => {
      if (!prevSelectedLectures) return null;

      return prevSelectedLectures.map((item) =>
        item.id === lecturer.id
          ? { ...item, activityType: selectedActivityType }
          : item,
      );
    });
  };

  useEffect(() => {
    const logic = async () => {
      const userIds: number[] = selectedLectures?.map((item) => item.id);
      console.log(`XXXXX userIds: ${userIds}`);

      const branch = globalConfigStore.rootFilter.currentBranches;
      if (branch) {
        const lecturerPaymentRateRes =
          await appApi.getUserLecturerPaymentRateByBranchId(userIds, branch.id);

        const lecturerPaymentRate = lecturerPaymentRateRes.data.body;
        setLecturerRateById(lecturerPaymentRate);
        console.log(`XXXXX userIds: ${JSON.stringify(lecturerPaymentRate)}`);
      }
    };

    if (selectedLectures && selectedLectures.length > 0) {
      logic();
    }
  }, [selectedLectures]);

  const handleOnSave = async () => {
    if (selectedLectures?.some((item) => !item.activityType)) {
      toast.warn('יש לבחור למרצה את סוג הפעילות המתאים');
      return;
    }

    const lecturesIds: {
      userId: number;
      activityTypeId: number;
      classId: number;
    }[] =
      selectedLectures?.map((item) => ({
        userId: item.id,
        activityTypeId: item.activityType!.lecturersRateType.id,
        classId: classId,
      })) ?? [];

    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    await addNewProtectorsOperations(
      currentProgramId,
      currentCourseId,
      examId,
      sessionId,
      lecturesIds,
      setExamDetails,
      onHide,
    );
  };

  return (
    <div>
      <label style={{ fontSize: '14px', color: '#4b5563' }}>בחירת מרצים</label>
      <FindUser
        role={UserType.LECTURER}
        displayTable={false}
        displayApprove={false}
        multiple={true}
        /*onApprove={() => {}}*/
        onChange={handleUsersChange}
      />

      {lecturerRateById &&
        selectedLectures.map((item) => (
          <div>
            <div
              style={{ marginTop: '8px', fontSize: '14px', color: '#4b5563' }}
            >
              בחירת סוג פעילות ל{`${item.firstName} ${item.lastName}`}
            </div>
            <Dropdown
              value={item.activityType || null}
              onChange={(e) =>
                handleSelectedActivityTypeForLecturer(item, e.value)
              }
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '36px',
              }}
              options={lecturerRateById[item.id]}
              optionLabel="lecturersRateType.typeRateName"
              itemTemplate={(option: LecturerRatesVersions) => {
                return option.lecturersRateType.typeRateName;
              }}
              placeholder="בחירת סוג פעילות"
            />
          </div>
        ))}

      <Button
        label={'אישור'}
        style={{ height: '30px', marginTop: '8px' }}
        onClick={handleOnSave}
      />
    </div>
  );
};
